export default __webpack_public_path__ + "static/media/login-bg.cd959813.png";